function toBase64Url(str) {
  const encoded = btoa(unescape(encodeURIComponent(str)));
  return encoded.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function fromBase64Url(base64url) {
  const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "=".repeat((4 - base64.length % 4) % 4);
  return decodeURIComponent(escape(atob(padded)));
}
function encodeProject(project) {
  return toBase64Url(JSON.stringify(project));
}
function decodeProject(data) {
  try {
    return JSON.parse(fromBase64Url(data));
  } catch {
    return null;
  }
}
export {
  decodeProject,
  encodeProject
};
